import { render, staticRenderFns } from "./ConfigDataTable.vue?vue&type=template&id=1b3467da&scoped=true&"
import script from "./ConfigDataTable.vue?vue&type=script&lang=js&"
export * from "./ConfigDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDataTable.vue?vue&type=style&index=0&id=1b3467da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3467da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b3467da')) {
      api.createRecord('1b3467da', component.options)
    } else {
      api.reload('1b3467da', component.options)
    }
    module.hot.accept("./ConfigDataTable.vue?vue&type=template&id=1b3467da&scoped=true&", function () {
      api.rerender('1b3467da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/configurationManager/ConfigDataTable.vue"
export default component.exports